
export const CONFIRMED_GET_OBJECTION = "CONFIRMED_GET_OBJECTION"
export const CONFIRMED_CREATE_OBJECTION = "CONFIRMED_CREATE_OBJECTION"
export const CONFIRMED_EDIT_OBJECTION = "CONFIRMED_EDIT_OBJECTION"
export const CONFIRMED_DELETE_OBJECTION = "CONFIRMED_DELETE_OBJECTION"
